import { MenuAddI, MenuI } from 'interfaces';
import { deleteById, get, patch, post } from 'services/services.methods';
import { Menus } from 'services/services.paths';

export const GetMenus = async () => {
  const response = await get<MenuI[]>(Menus.menu);

  return response;
};

export const DeleteMenuService = async (id: number) => {
  const response = await deleteById<MenuI>(Menus.menu, id);

  return response;
};

export const AddOMenuService = async (menu: MenuAddI) => {
  const response = await post<MenuI>(Menus.menu, menu);

  return response;
};
export const UpdateMenuService = async (menu: MenuAddI, id: string) => {
  const response = await patch<MenuI>(Menus.menu + '/' + id, menu);

  return response;
};


